import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DialogComponent } from '../dialog-component';
import { Shell } from '../shell';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})

export class ConfirmationDialogComponent extends DialogComponent {
  private domSanitizer = inject(DomSanitizer);

  init(
    title: string, 
    message: string, 
    callback: (confirmed : boolean) => void, 
    options?: { 
      confirmText?: string,
      cancelText?: string
    }
  ) {
    this.title = title;
    this.message = this.domSanitizer.bypassSecurityTrustHtml(message);
    this.callback = callback;

    if (options) {
      this.confirmText = options.confirmText ?? this.confirmText;
      this.cancelText = options.cancelText ?? this.cancelText;
    }
  }

  message: string | SafeHtml;
  callback : (confirmed: boolean) => void;
  title: string | SafeHtml;
  confirmText: string;
  cancelText: string;

  async confirm() {
    this.callback(true);
    this.close();
  }

  async cancel() {
    this.callback(false);
    this.close();
  }

  get pageComponentId() {
    return 'confirm';
  }

}

Shell.__confirmationDialogComponent = ConfirmationDialogComponent;
